<template>
  <div>
    <h2 v-if="title" class="heading-1 text-center mb-8">{{ title }}</h2>
    <ClientOnly>
      <div class="grid gap-4 md:gap-8 grid-cols-2 md:grid-cols-3">
        <Person v-for="person in people" :key="person.name" v-bind="person" />
      </div>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
  import { useQuery } from '@vue/apollo-composable'

  import { GET_TEAM_MEMBERS } from '../../queries'
  import { Person } from '..'

  defineProps({ title: String })

  const { result } = useQuery(GET_TEAM_MEMBERS)

  const people = computed(() =>
    result.value?.teamMembers?.map(
      (teamMember: {
        name: string
        role?: string
        pronouns?: string
        image: { url: string }
        altImage: { url?: string }
      }) => ({
        ...teamMember,
        imageUrl: teamMember.image?.url,
        alternateImageUrl: teamMember.altImage?.url,
      })
    )
  )
</script>
